'use strict';

class Translator {
	static getInstance(){
		site.translator = site.translator || new Translator();
		return site.translator;
	}

	constructor() {
		this.tables = {};
		this.defaultTable = null;

		_.bindAll(this, 'addLanguageTable');
		return this;
	}

	addLanguageTable(lang, table, isDefault = false) {
		this.tables[lang] = table;
		if(isDefault) this.defaultTable = table;
		return this;
	}
}


function _t(val){
	let i = Translator.getInstance();
	if(!i.defaultTable) return val;
	let res = i.defaultTable[val];
	return res;
}
